(() => {
  const renderedView = document.currentScript?.dataset.renderedView;
  const productPath = '/products/second-spring®-metabolic-balance-softgels';
  const hosts = new Set([location.hostname, 'trysecondspring.co', 'www.trysecondspring.co', 'pgkuf0-c1.myshopify.com']);
  const isProduct = url => hosts.has(url.hostname) && decodeURIComponent(url.pathname).replace(/\/$/, '').endsWith(productPath);
  const markerKey = 'ss-product-navigation';
  const current = new URL(location.href);
  let fromNavigation = false;
  try {
    const marker = JSON.parse(sessionStorage.getItem(markerKey) || 'null');
    fromNavigation = marker && Date.now() - marker.time < 30000 && marker.path === current.pathname;
    if (isProduct(current)) sessionStorage.removeItem(markerKey);
  } catch (_) {}
  try { if (document.referrer && !isProduct(new URL(document.referrer))) fromNavigation = true; } catch (_) {}

  // Shopify selects the alternate template server-side. Once rendered, the
  // checkbox response immediately restores the clean public URL below.
  if (isProduct(current) && renderedView !== 'checkbox' && fromNavigation && !window.Shopify?.designMode) {
    const alternate = new URL(current);
    alternate.searchParams.set('view', 'checkbox');
    location.replace(alternate.href);
    return;
  }
  // Also normalize older shared checkbox URLs after their template has loaded.
  if (renderedView === 'checkbox' && current.searchParams.get('view') === 'checkbox') {
    current.searchParams.delete('view');
    history.replaceState(history.state, '', current.pathname + current.search + current.hash);
  }
  function updateLink(link) {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    try {
      const url = new URL(href, location.href);
      if (isProduct(url) && url.searchParams.get('view') === 'checkbox') {
        url.searchParams.delete('view');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    } catch (_) {}
  }
  function updateTree(root) {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  }
  function init() {
    updateTree(document);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') updateLink(record.target);
      else record.addedNodes.forEach(updateTree);
    })).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['href']});
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    updateLink(link);
    try {
      const target = new URL(link.href);
      if (isProduct(target) && !isProduct(new URL(location.href))) {
        sessionStorage.setItem(markerKey, JSON.stringify({path:target.pathname, time:Date.now()}));
      }
    } catch (_) {}
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
